import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqs } from "@/mocks/homeContent";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="第一次接触时最常问的几件事"
          desc="把用户搜索与浏览时最可能出现的问题集中解答，点击标题即可展开完整回答。"
          align="center"
        />

        <div className="mx-auto mt-10 max-w-3xl space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/60"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {faq.q}
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-lg text-primary-600">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-7 text-foreground-600 md:text-base">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}